import React from 'react';
import { ArrowRightIcon, AwardIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CourseCardProps {
  title: string;
  subtitle: string;
  description: string;
  points: number;
  imageUrl: string;
  slug: string;
}
export function CourseCard({
  title,
  subtitle,
  description,
  points,
  imageUrl,
  slug
}: CourseCardProps) {
  return <div className="bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-2xl transition-all duration-500 flex flex-col h-full group hover:-translate-y-2" data-id="element-319">
      <div className="relative h-64 overflow-hidden" data-id="element-320">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-321" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-322"></div>
        <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg flex items-center gap-2 border border-slate-100 transform group-hover:scale-105 transition-transform" data-id="element-323">
          <AwardIcon className="w-5 h-5 text-amber-500" data-id="element-324" />
          <span className="text-sm font-extrabold text-slate-700" data-id="element-325">
            {points} Punkte
          </span>
        </div>
      </div>

      <div className="p-5 sm:p-8 flex flex-col flex-grow relative bg-white" data-id="element-326">
        <div className="mb-4" data-id="element-327">
          <p className="text-[#59d0d4] font-extrabold text-xs uppercase tracking-widest mb-2" data-id="element-328">
            {subtitle}
          </p>
          <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 leading-tight group-hover:text-[#3b7780] transition-colors" data-id="element-329">
            {title}
          </h3>
        </div>

        <p className="text-slate-500 mb-6 sm:mb-8 flex-grow font-medium leading-relaxed" data-id="element-330">
          {description}
        </p>

        <Link to={`/kurse/${slug}`} className="inline-flex items-center justify-between w-full px-6 py-4 bg-slate-50 hover:bg-[#3b7780] text-slate-700 hover:text-white font-bold rounded-xl transition-all duration-300 border border-slate-200 hover:border-transparent group/btn" data-id="element-331">
          <span data-id="element-332">Zum Kurs</span>
          <ArrowRightIcon className="w-5 h-5 transform group-hover/btn:translate-x-2 transition-transform" data-id="element-333" />
        </Link>
      </div>
    </div>;
}